import React from 'react';
import PropTypes from 'prop-types';
import { OnOff } from 'bv-components';
import { withFold } from 'bv-hocs';
import { t } from 'bv-i18n';
import Player from './player';

const eventDate = (datetime) => datetime
  .split(' ')
  .slice(1)
  .join(' ');

const eventHour = (datetime) => datetime
  .split(' ')
  .slice(0, 1);

const Darts = ({
  toggleFolded, folded, match_preview: matchPreview, datetime, player1, player2,
}) => (
  <div className="extra-information">
    <div className="bvs-card event-overview darts off darts-event--overview coupon-list">
      <div className="info-wrapper">
        <span className="title darts-info--title">
          { t('javascript.event_extra_information.darts.title') }
          <em>{ t('javascript.event_extra_information.darts.subtitle') }</em>
        </span>
        <OnOff onChange={toggleFolded} checked={!folded} />
        <br />
        { matchPreview }
        <span className="footer-note">
          { t('javascript.event_extra_information.darts.footer') }
        </span>
        <span className="fake-ellipsis">[...]</span>
      </div>

      {
        !folded && (
          <ul className="darts-stats">
            <li className="list-header darts-stats--header">
              <span className="event-date">{ eventDate(datetime) }</span>
              <span className="event-hour">{ eventHour(datetime) }</span>
            </li>

            <Player {...{ playerIndex: 1, ...player1 }} />
            <Player {...{ playerIndex: 2, ...player2 }} />
          </ul>
        )
      }
    </div>
  </div>
);

Darts.propTypes = {
  toggleFolded: PropTypes.func.isRequired,
  folded: PropTypes.bool.isRequired,
  match_preview: PropTypes.string.isRequired,
  datetime: PropTypes.string.isRequired,
  player1: PropTypes.instanceOf(Object).isRequired,
  player2: PropTypes.instanceOf(Object).isRequired,
};

export default withFold(Darts);
